const Signal = require('signals');

enum EVENTS {
    LOGIN = 'login',
    ADD_ENTRY = 'addEntry',
    UPDATE_REPORTS = 'updateReports',
    UPDATE_CURRENT_REPORT = 'updateCurrentReport',
    SET_ENTRIES = 'setEntries',
    UPDATE_ENTRY = 'updateEntry',
    INSERT_ENTRY = 'insertEntry',
    SET_UPLIFT_ENTRIES = 'setUpliftEntries',
    SET_ENTRY_ADS = 'setEntryAds',
    UPDATE_UPLIFTS_LAYOUT = 'updateUpliftsLayout',
    UPDATE_ENTRIES_LAYOUT = 'updateEntriesLayout',
    SET_MY_UPLIFT_ENTRIES = 'setMyUpliftEntries',
    SET_TASK_LISTS = 'setTaskLists',
    UPDATE_UPLIFT_ENTRY = 'updateUpliftEntry',
    BEGIN_EDIT_ENTRY = 'beginEditEntry',
    BEGIN_UPLIFT_ENTRY = 'beginUpliftEntry',
    BEGIN_UPLIFT_CONTRIBUTE = 'beginUpliftContribute',
    BEGIN_ADD_ENTRY = 'beginAddEntry',
    BEGIN_EDIT_ENTRY_PAYMENTS = 'beginEditEntryPayments',
    END_ADD_ENTRY = 'endAddEntry',
    END_EDIT_ENTRY = 'endEditEntry',
    END_UPLIFT_CONTRIBUTE = 'endUpliftContribute',
    END_UPLIFT_ENTRY = 'endUpliftEntry',
    END_EDIT_ENTRY_PAYMENTS = 'endEditEntryPayments',
    UPDATE_ALL_ENTRIES = 'updateAllEntries',
    UPDATE_TASKS = 'updateTasks',
    RESET_TASKS = 'resetTasks',
    REMOVE_ENTRY = 'removeEntry',
    UPDATE_SELECTED_TASK_LIST = 'updateSelectedTaskList',
    UPDATE_LIST_LIMITS = 'updateListLimits',
    UPDATE_IGNORED_TASK_LIST = 'updateIgnoredTaskList',
    RESET_TASK_LIST = 'resetTaskList',
    UPDATE_SEARCH_LAYOUT = 'updateSearchLayout',
    GET_STATS = 'getStats',
    SHOW_ADD_ENTRY = 'showAddEntry',
    SHOW_EDIT_ENTRY = 'showEditEntry',
    SHOW_UPLIFT_CONTRIBUTE = 'showUpliftContribute',
    SHOW_UPLIFT_ENTRY = 'showUpliftEntry',
    SHOW_EDIT_ENTRY_PAYMENTS = 'showEditEntryPayments',
    SERVICE_ERROR = 'serviceError'
}

export enum LOADER_EVENTS {
    LOAD_LISTS = 'loadLists',
    LOAD_ENTRIES = 'loadEntries',
    LOAD_REPORTS = 'loadReports',
    LOAD_NEW_ENTRY = 'loadNewEntry',
    LOAD_STATS = 'loadStats'
}

export const EVENT_KEYS = {
    ...EVENTS,
    ...LOADER_EVENTS
};

export class LoginSignal extends Signal {}
export class AddEntrySignal extends Signal {}
export class RequestBeginAddEntrySignal extends Signal {}
export class SelectListSignal extends Signal {}
export class CreateListSignal extends Signal {}
export class DeleteListSignal extends Signal {}
export class UpdateTaskSignal extends Signal {}
export class UpdateEntriesSignal extends Signal {}
export class RequestTasksSignal extends Signal {}
export class RequestEditTaskSignal extends Signal {}
export class RequestEditTaskPaymentsSignal extends Signal {}
export class RequestResetTaskListSignal extends Signal {}
export class RequestGotoTaskListItemSignal extends Signal {}
export class RequestUpdateEntryDialogsLayout extends Signal {}
export class RequestUpdateSearchLayoutSignal extends Signal {}
export class RequestUpliftSignal extends Signal {}
export class RequestCreateUpliftSignal extends Signal {}
export class RequestUpliftEntriesSignal extends Signal {}
export class RequestUpliftContributeSignal extends Signal {}
export class RequestCreateContributionSignal extends Signal {}
export class RequestUpdateUpliftLayoutSignal extends Signal {}
export class RequestUpdateEntriesLayoutSignal extends Signal {}
export class RequestStatsSignal extends Signal {}
export class RequestTaskListsSignal extends Signal {}
export class RequestUpdateReportSignal extends Signal {}
export class RequestSaveReportSignal extends Signal {}
export class RequestDeleteReportSignal extends Signal {}
export class RequestReportsSignal extends Signal {}
export class UpdateListLimitsSignal extends Signal {}
